import { Injectable, isDevMode } from '@angular/core';
import { CanActivate, CanActivateChild, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';


@Injectable()
export class DevGuard implements CanActivate, CanActivateChild {

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        let hasAccess = isDevMode();
        return hasAccess;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

}
